import {
	observer
} from 'mobx-react';
import {
	WeaDialog,
	WeaTab,
} from 'ecCom';
import {
	WeaTableNew
} from 'comsMobx';
const WeaTable = WeaTableNew.WeaTable;

@observer
export default class LogDialog extends React.Component {
	render() {
		const {
			store
		} = this.props, {
			hrmAddressBookPlus: plusStore
		} = store, {
			DIALOG_SYNCLOG,
			synclogDialog,
			synclogTitle,
			SEARCH_SYNCLOG,
			share,
			TABLE,
		} = plusStore, {
			tab,
			searchsAd,
			table,
		} = share;

		return (
			<WeaDialog ecId={`${this && this.props && this.props.ecId || ''}_WeaDialog@cbyabi`} {...DIALOG_SYNCLOG} {...synclogDialog} title={synclogTitle} >
				<WeaTab ecId={`${this && this.props && this.props.ecId || ''}_WeaTab@6w22cq`} {...SEARCH_SYNCLOG} {...tab} searchsAd={searchsAd}/>
				<WeaTable ecId={`${this && this.props && this.props.ecId || ''}_WeaTable@imqr0s`} {...TABLE} {...table}/>
			</WeaDialog>
		);
	}
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/components/addressBookPlus/LogDialog.js